<template>
    <div class="boleto-payment-form">
        <div class="boleto-generation">
            <!-- Desktop -->
            <div class="row d-none d-md-flex">
                <div class="col-9 d-flex align-items-center">
                    <div class="row d-flex justify-content-center">
                        <div class="col-9">
                            <div class="row mb-2">
                                <div class="col-1 d-flex flex-column justify-content-center">
                                    <hr class="m-0">
                                </div>
                                <div class="col-2 d-flex justify-content-center">
                                    <div class="item-icon">1</div>
                                </div>
                                <div class="col-2 d-flex flex-column justify-content-center">
                                    <hr class="m-0">
                                </div>
                                <div class="col-2 d-flex justify-content-center">
                                    <div class="item-icon">2</div>
                                </div>
                                <div class="col-2 d-flex flex-column justify-content-center">
                                    <hr class="m-0">
                                </div>
                                <div class="col-2 d-flex justify-content-center">
                                    <div class="item-icon">3</div>
                                </div>
                                <div class="col-1 d-flex flex-column justify-content-center">
                                    <hr class="m-0">
                                </div>
                            </div>
                            <div class="row d-flex justify-content-center">
                                <div class="col-4 text-align-center" style="text-align: center">
                                    {{ $t("Clique em 'Gerar' para visualizar o boleto.") }}
                                </div>
                                <div class="col-4 text-align-center" style="text-align: center">
                                    {{ $t("Imprima ou utilize o código de barras para realizar o pagamento.") }}
                                </div>
                                <div class="col-4 text-align-center" style="text-align: center">
                                    {{ $t("Seu pagamento pode levar até 72 horas para ser compensado.") }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-3 d-flex flex-column justify-content-end">
                    <div class="row">
                        <div class="col-6">
                            <button @click="close()" id="closeButton" class="btn btn-dark btn-block"> Voltar </button>
                        </div>
                        <!-- Inicial -->
                        <div class="col-6" v-if="!loading && !boleto.generated">
                            <button @click="submit" id="generateButton" class="btn btn-primary btn-block"> Gerar </button>
                        </div>
                        <!-- Carregamento -->
                        <div v-else-if="loading && !boleto.generated" class="col-6">
                            <button class="btn btn-block fill-height btn-primary d-flex justify-content-center align-items-center" style="height: 100%" type="button" disabled>
                                <div class="spinner-border spinner-border-sm text-light small" role="status"></div>
                            </button>
                        </div>
                        <!-- Após geração -->
                        <div v-else class="col-6">
                            <button id="generateButton" class="btn btn-primary disabled btn-block"> Gerado </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Mobile -->
            <div class="row d-flex d-md-none">
                <div class="col-12">
                    <div class="row d-flex justify-content-center">
                        <div class="col-4 d-flex flex-column justify-content-center">
                            <hr class="m-0">
                        </div>
                        <div class="col-4 d-flex justify-content-center">
                            <div class="item-icon">1</div>
                        </div>
                        <div class="col-4 d-flex flex-column justify-content-center">
                            <hr class="m-0">
                        </div>
                    </div>
                    <div class="row text-align-center my-3">
                        <div class="col-12" style="text-align: center;">
                            Clique em "Gerar" para visualizar o boleto.
                        </div>
                    </div>
                    <div class="row d-flex justify-content-center">
                        <div class="col-4 d-flex flex-column justify-content-center">
                            <hr class="m-0">
                        </div>
                        <div class="col-4 d-flex justify-content-center">
                            <div class="item-icon">2</div>
                        </div>
                        <div class="col-4 d-flex flex-column justify-content-center">
                            <hr class="m-0">
                        </div>
                    </div>
                    <div class="row text-align-center my-3" style="text-align: center;">
                        <div class="col-12">
                            Imprima ou utilize o código de barras para realizar o pagamento.
                        </div>
                    </div>
                    <div class="row d-flex justify-content-center">
                        <div class="col-4 d-flex flex-column justify-content-center">
                            <hr class="m-0">
                        </div>
                        <div class="col-4 d-flex justify-content-center">
                            <div class="item-icon">3</div>
                        </div>
                        <div class="col-4 d-flex flex-column justify-content-center">
                            <hr class="m-0">
                        </div>
                    </div>
                    <div class="row text-align-center my-3" style="text-align: center;">
                        <div class="col-12">
                            Seu pagamento pode levar até 72 horas para ser compensado.
                        </div>
                    </div>
                </div>
                <div class="col-12 d-flex flex-column justify-content-end">
                    <div class="row">
                        <div class="col-6">
                            <button @click="close()" id="closeButton" class="btn btn-dark btn-block"> Voltar </button>
                        </div>
                        <!-- Inicial -->
                        <div class="col-6" v-if="!loading && !boleto.generated">
                            <button @click="submit" id="generateButton" class="btn btn-primary btn-block"> Gerar </button>
                        </div>
                        <!-- Carregamento -->
                        <div v-else-if="loading && !boleto.generated" class="col-6">
                            <button class="btn btn-block fill-height btn-primary d-flex justify-content-center align-items-center" style="height: 100%" type="button" disabled>
                                <div class="spinner-border spinner-border-sm text-light small" role="status"></div>
                            </button>
                        </div>
                        <!-- Após geração -->
                        <div v-else class="col-6">
                            <button id="generateButton" class="btn btn-primary disabled btn-block"> Gerado </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="boleto.generated" class="boleto-print">
            <iframe :src="boleto.payment.url" style="width: 100%; height: 1080px; margin-top: 24px" frameborder="0"></iframe>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import recaptcha from '../../../plugins/recaptcha';

export default Vue.extend({
    data() {
        return {
            selected: 0,
            boleto: {
                generated: false,
            },
            loading: false,
        }
    },
    props: {
        cart: {
            required: true,
            type: Object
        },
        error: {
            required: true,
            type: Object
        },
        installments: {},
    },
    methods: {
        async submit() {
            this.loading = true
            
            try {
                const token = await recaptcha()
    
                const response = await axios.post('/api/payment/pay', {
                    cart: this.cart,
                    type: 'boleto',
                    token: token
                });
                
                if (!response.data.error) {
                    this.boleto.payment = response.data.payment
                    this.boleto.generated = true
                    this.error.condition = false
                    // this.$emit('success', { redirect: false })
                }
            } catch (exception) {
                this.error.condition = true
                this.error.message = "Ocorreu um erro ao gerar seu boleto, tente novamente mais tarde."
            } finally {
                this.loading = false
            }
        },
        close() {
            this.$emit('close')
        }
    }
})
</script>
